// @flow strict

import { Input, message, Row, Col, Radio, Spin, InputNumber } from "antd";
import Modal from "antd/lib/modal/Modal";
import ProductInputNumber from "components/InputWidgets/InputNumber/ProductInputNumber";
import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import "./EditIngredientDialog.css"
import ProductDescriptionInput from "components/ProductPage/ProductDescriptionInput/ProductDescriptionInput";
function EditIngredientDialog(props) {
  const { show, proceed, record } = props;
  const [errorField, setErrorField] = useState([]);
  const [selIngredient, setSelIngredient] = useState({});
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    if (record !== undefined) {
      setSelIngredient(record);
    }
  }, [record]);

  const onOkAction = async () => {
    if (parseFloat(selIngredient['total_enter_qty'])  <= 0) {
      message.error("Please Enter QTY")
      return
    }
    selIngredient["dataList"][0]["enter_qty"] = selIngredient['total_enter_qty']
    proceed({
      editedItem: selIngredient,
    });
  }
  
  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="custom-base-edit-ingredient-dlg"
      closable={true}
      maskClosable={false}
      title={`Edit ` + selIngredient['name']}
      onOk={() => {
        onOkAction()
      }}
    >
      <Spin spinning={isBusy}>
      <Row align={"middle"} gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div>QTY*</div>
          <ProductInputNumber
            field={"total_enter_qty"}
            min={"0.0000001"}
            productInfo={selIngredient}
            setProductInfo={setSelIngredient}
            errorField={errorField}
            setErrorField={setErrorField}
          />
        </Col>
      </Row>
      </Spin>
    </Modal>
  );
}

export default confirmable(EditIngredientDialog);
